import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Drawer, Checkbox, Toggle, ExpandableSection, FlashbarProps, Flashbar, Select, FormField, Multiselect, TimeInput, DateRangePicker, DateRangePickerProps, Input, Container, Modal, Calendar, RadioGroup, Link, Form, Tiles, TextContent, SegmentedControl } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
//import Icon from "@cloudscape-design/components/icon";
import { formatPhone, isEmail, isValidPhone, storeJWT } from '../../../commons/functions';
import { format, addHours } from 'date-fns';
import { formatInTimeZone } from "date-fns-tz";
import Icon from '@mdi/react';
import { mdiWalk, mdiPackageVariantClosedCheck, mdiMopedOutline, mdiBike, mdiTruckOutline, mdiMotorbike, mdiCarBack, mdiBellBadgeOutline, mdiLock, mdiBell } from '@mdi/js';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { validateRut, formatRut } from '@fdograph/rut-utilities';

interface Unit {
    label: string;
    value: string;
    description?: string;
}

interface User {
    label: string;
    value: string;
    description?: string;
}

interface Access {
    label: string;
    value: string;
    description?: string;
}
interface Props {
    accesses: Access[]; // The array of all available access options
    onAccessChange: (selectedAccesses: Access[]) => void; // Callback to handle changes
    initialAccess?: Access[]; // Optional initial selected values
}
export const NotificationsAddPage = () => {
    const storeAdmin = useStoreAdmin();
    const earlierDate = formatInTimeZone(new Date(), "America/Santiago", "yyyy-MM-dd'T'HH:mm:ss");

    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [modalMessages, setModalMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();

    const { gData, setGData } = useGlobalState();
    //const { gData, setGData } = useGlobalState();


    const [btnAuths, setBtnAuths] = useState(true);
    const [showDetails, setShowDetails] = useState(false);
    const [notificationType, setNotificationType] = useState('');

    const [name, setName] = useState('');
    const [hasName, setHasName] = useState(true);
    const [reqName, setReqName] = useState(true);

    const [RUT, setRUT] = useState('');
    const [hasRUT, setHasRUT] = useState(true);
    const [reqRUT, setReqRUT] = useState(true);

    const [company, setCompany] = useState('');
    const [hasCompany, setHasCompany] = useState(true);
    const [reqCompany, setReqCompany] = useState(true);

    const [PPU, setPPU] = useState('');
    const [hasPPU, setHasPPU] = useState(true);
    const [reqPPU, setReqPPU] = useState(true);

    const [obsEmisor, setObsEmisor] = useState('');
    const [hasObsEmisor, setHasObsEmisor] = useState(true);
    const [reqObsEmisor, setReqObsEmisor] = useState(true);


    const [DPVisible, setDPVisible] = useState(false);
    const [allDay, setAllDay] = useState(false);



    const [transport, setTransport] = useState("");
    const [hasTransport, setHasTransport] = useState(true);
    const [reqTransport, setReqTransport] = useState(true);



    const [PAX, setPAX] = useState('');
    const [hasPAX, setHasPAX] = useState(true);
    const [reqPAX, setReqPAX] = useState(true);

    const [visitorsReqAuth, setVisitorsReqAuth] = useState(0);
    const [deliveryReqAuth, setDeliveryReqAuth] = useState(0);
    const [mailingReqAuth, setMailingReqAuth] = useState(0);


    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const { setLoading } = useGlobalState();
    const [loadingGenerate, setLoadingGenerate] = useState<boolean>(false);
    const [showUnit, setShowUnit] = useState<boolean>(false);

    const [guest, setGuest] = useState<string>('');


    //const [date, setDate] = React.useState(undefined);


    const [users, setUsers] = useState<User[]>([]);
    const [user, setUser] = useState<User | undefined>();
    const [filteredUsers, setFilteredUsers] = useState<User[]>([]);

    const [units, setUnits] = useState<Unit[]>([]);
    const [unit, setUnit] = useState<Unit | undefined>();
    const [property, setProperty] = useState<any>();
    const inputRefRUT = useRef<HTMLInputElement>(null);
    const handleRUTBlur = async () => {
        // Optionally revalidate or format inputRUT here
        const rut = RUT.replace(/[^0-9Kk\-]/g, '').toUpperCase().trim();
        if (rut && rut !== "" && validateRut(rut)) {
            setRUT(formatRut(rut))
            setMessages([])

            try {
                const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/admin/rut/name',
                        'JWT': JWT,

                    },
                    body: JSON.stringify({ RUT: rut })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                if (data.RUT && data.RUT.name && data.RUT.name !== '') {
                    setName(data.RUT.name)
                }


            } catch (error: any) {
            } finally {

            }

        } else {
            setRUT("")
            setMessages([
                {
                    type: 'error',
                    content: 'RUT inválido',
                    id: 'error-msg',
                },
            ]);
        }
    };

    const handleGenerate = async () => {
        let body = {
            idUnidad: Number(unit?.value),
            idControl: Number(user?.value),
            notificationType: notificationType,
            empresa: company,
            nombre: name,
            transport: transport,
            pax: PAX,
            PPU: PPU,
            obsEmisor: obsEmisor,
        }
        if (hasRUT && reqRUT && RUT === '') {
            setMessages([{ type: 'error', content: 'Ingrese un RUT válido}.', dismissible: true }]);
            return;
        }
        if (hasName && reqName && name === '') {
            setMessages([{ type: 'error', content: 'Ingrese el nombre.', dismissible: true }]);
            return;
        }
        if (hasTransport && reqTransport && transport === '') {
            setMessages([{ type: 'error', content: 'Seleccione el medio de transporte.', dismissible: true }]);
            return;
        }
        if (hasPAX && reqPAX && PAX === '') {
            setMessages([{ type: 'error', content: 'Indique cantidad de ocupantes.', dismissible: true }]);
            return;
        }
        if (hasCompany && reqCompany && company === '') {
            setMessages([{ type: 'error', content: 'Ingrese el nombre de la empresa.', dismissible: true }]);
            return;
        }
        if (hasPPU && reqPPU && PPU === '') {
            setMessages([{ type: 'error', content: 'Ingrese la matrícula del transporte.', dismissible: true }]);
            return;
        }
        setLoading(true)
        try {
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/notifications/add',
                    'JWT': JWT,

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                window.location.hash = "#notifications/list"
            } else {

                setMessages([
                    {
                        type: 'error',
                        content: `Error al contactar el servidor: ${data.status}`,
                        id: 'server-error',
                    },
                ]);
            }

        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            //setPendingJobCreation(false);

            setLoading(false)
        }

        ///

    }

    const handleUnits = async () => {
        setLoading(true)
        try {
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/units/list',
                    'JWT': JWT,

                },
                body: JSON.stringify({})
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {



                const mapped: Unit[] = data.units
                    .filter((item: { users: number }) => item.users > 0)
                    .map((item: { unidad: string; idUnidad: string }) => ({
                        label: item.unidad,
                        value: item.idUnidad.toString(),
                    }));
                setUnits(mapped);

            }

        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            //setPendingJobCreation(false);

            setLoading(false)
        }

        ///

    }
    useEffect(() => {

        //
        handleUnits()
        setMessages([]);
    }, []); // The effect runs every time selectedAccesses changes

    useEffect(() => {
        setMessages([]);
    }, [guest]);

    const handleGetUsers = async () => {
        setMessages([]);
        setUsers([]);
        setShowUnit(false);
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?3', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/units/getunit',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idUnidad: unit?.value,
                    property: true,

                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                setUser({ label: "", value: "", description: "" });
                const mapped: User[] = data.users.map((item: { displayName: any; movil: any; idControl: { toString: () => any; }; }) => ({
                    label: `${item.displayName} (${formatPhone(item.movil)})`,
                    value: item.idControl.toString()
                }));
                console.log(mapped)
                setProperty(data.property)
                setUsers(mapped)
                // When users are loaded or updated, set filteredUsers to the full list
                setFilteredUsers(users);
                if (mapped.length === 1) {
                    setUser(mapped[0]);
                }
            }
            setShowUnit(true);
            //setUsers(data.admins);

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setShowUnit(false);
        setUsers([]);
        if (unit !== undefined) {
            handleGetUsers();
        }
    }, [unit]);
    //'System.Object[]'




    return (
        <CustomAppLayout
            toolsHide={true}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Notificaciones', href: '#notifications/default' },
                        { text: 'Generar', href: '#notifications/add' },
                        /*{ text: 'Listar notificaciones', href: '#create-transcription-job' },*/
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Form
                        actions={
                            <SpaceBetween direction="horizontal" size="xs">

                                <Button loading={loadingGenerate} disabled={!showUnit} variant='primary' onClick={() => handleGenerate()}>
                                    Generar
                                </Button>
                            </SpaceBetween>
                        }
                        header={<Header variant="h1">Generar notificación</Header>}
                    >
                        <Container>
                            <Flashbar items={messages} />
                            <SpaceBetween direction="vertical" size="xs">
                                <SpaceBetween direction="horizontal" size="xs">

                                    <FormField
                                        description="Seleccione unidad para desplegar usuarios."
                                        label="Unidad"
                                    >
                                        <Select
                                            selectedOption={unit ?? null}
                                            loadingText='Cargando unidades...'
                                            onChange={({ detail }) => {
                                                setUnit(detail.selectedOption as Unit);
                                            }}
                                            options={units}
                                            placeholder="Seleccionar"
                                            filteringType="auto"
                                        //selectedOption={null}
                                        ></Select>
                                    </FormField>
                                    {showUnit && (
                                        <FormField
                                            description="Seleccione usuario recibirá la notificación"
                                            label="Destinatario"
                                        >
                                            <Select
                                                loadingText='Cargando usuarios...'
                                                selectedOption={user ?? null}
                                                onChange={({ detail }) => {
                                                    setUser(detail.selectedOption as User);
                                                    setMessages([]);
                                                }}

                                                options={filteredUsers}
                                                placeholder="Seleccionar"
                                                filteringType="manual"
                                                onLoadItems={({ detail }) => {
                                                    const query = detail.filteringText.toLowerCase();
                                                    const words = query.split(/\s+/).filter(Boolean); // Split and remove empty parts

                                                    const results = users.filter(user => {
                                                        const label = `${user.label}`.toLowerCase(); // or any searchable fields concatenated
                                                        return words.every(word => label.includes(word));
                                                    });

                                                    setFilteredUsers(results); // You'll need `const [filteredUsers, setFilteredUsers] = useState<User[]>(users);`
                                                }}
                                            //selectedOption={null}
                                            ></Select>
                                        </FormField>
                                    )}
                                </SpaceBetween>
                                {showUnit && (
                                    <>
                                        <FormField
                                            label="Tipo de notificación"
                                            constraintText={""}>

                                            <SegmentedControl
                                                selectedId={notificationType}
                                                onChange={({ detail }) => {

                                                    setShowDetails(false);
                                                    setNotificationType(detail.selectedId);
                                                    let reqInfo = [];
                                                    let info = [];

                                                    if (detail.selectedId === "VISIT") {
                                                        reqInfo = property.visitorsInfoReq.toString().split(",")
                                                        info = property.visitorsInfo.toString().split(",")
                                                        //"RUT,NOMBRE,TRANSPORT,PAX,EMPRESA,PPU,IMG"
                                                    } else if (detail.selectedId === "DELIVERY") {
                                                        reqInfo = property.deliveryInfoReq.toString().split(",")
                                                        info = property.visitorsInfo.toString().split(",")
                                                    } else if (detail.selectedId === "MAIL") {
                                                        reqInfo = property.mailingInfoReq.toString().split(",")
                                                        info = property.mailingInfo.toString().split(",")
                                                    }
                                                    setHasName(info.includes("NOMBRE"));
                                                    setHasRUT(info.includes("RUT"));
                                                    setHasPPU(info.includes("PPU"));
                                                    setHasCompany(info.includes("EMPRESA"));
                                                    setHasTransport(info.includes("TRANSPORT"));
                                                    setHasPAX(info.includes("PAX"));


                                                    setReqName(reqInfo.includes("NOMBRE"));
                                                    setReqRUT(reqInfo.includes("RUT"));
                                                    setReqPPU(reqInfo.includes("PPU"));
                                                    setReqCompany(reqInfo.includes("EMPRESA"));
                                                    setReqTransport(reqInfo.includes("TRANSPORT"));
                                                    setReqPAX(reqInfo.includes("PAX"));


                                                    setShowDetails(true);

                                                }}
                                                label="Tipo de Notificación"
                                                options={[
                                                    { text: "Visita", id: "VISIT", iconSvg: <Icon path={mdiBellBadgeOutline} size={0.7} /> },
                                                    { text: "Delivery", id: "DELIVERY", iconSvg: <Icon path={mdiPackageVariantClosedCheck} size={0.7} /> },
                                                    { text: "Correo", id: "MAIL", iconSvg: <Icon path={mdiPackageVariantClosedCheck} size={0.7} /> }
                                                ]}
                                            />
                                        </FormField>
                                        {showDetails && notificationType === 'DELIVERY' && (
                                            property.deliveryReqAuth === 1 ? (<span><Icon path={mdiLock} size={0.7} color="red" /> Usuario debe autorizar o denegar el delivery</span>) : (<span><Icon path={mdiBell} size={0.7} color="gray" /> Solo notifica al usuario</span>)
                                        )}
                                        {showDetails && notificationType === 'VISIT' && (
                                            property.visitorsReqAuth === 1 ? (<span><Icon path={mdiLock} size={0.7} color="red" /> Usuario debe autorizar o denegar la visita</span>) : (<span><Icon path={mdiBell} size={0.7} color="gray" /> Solo notifica al usuario</span>)
                                        )}
                                        {showDetails && notificationType === 'MAIL' && (
                                            property.mailingReqAuth === 1 ? (<span><Icon path={mdiLock} size={0.7} color="red" /> Usuario debe autorizar o denegar la encomienda</span>) : (<span><Icon path={mdiBell} size={0.7} color="gray" /> Solo notifica al usuario</span>)
                                        )}
                                        {showDetails && (
                                            <>
                                                {hasRUT && (
                                                    <FormField
                                                        label={`RUT${reqRUT ? " *" : ""}`}
                                                        constraintText={reqRUT ? "" : "*Campo opcional"}>
                                                        <Input
                                                            value={RUT}
                                                            onChange={({ detail }) => {
                                                                setRUT(detail.value)
                                                                setMessages([]);
                                                            }}
                                                            ref={inputRefRUT}
                                                            onBlur={handleRUTBlur}
                                                            placeholder=""
                                                        ></Input>
                                                    </FormField>
                                                )}
                                                {hasName && (
                                                    <FormField
                                                        label={`Nombre${reqName ? " *" : ""}`}
                                                        constraintText={!reqName ? "" : "*Campo opcional"}>
                                                        <Input
                                                            value={name}
                                                            onChange={({ detail }) => {
                                                                setName(detail.value)
                                                                setMessages([]);
                                                            }}
                                                            placeholder=""
                                                        ></Input>
                                                    </FormField>
                                                )}

                                                {(hasPAX || hasTransport) && (
                                                    <SpaceBetween direction='vertical' size='xs'>
                                                        {hasTransport && (
                                                            <TextContent>
                                                                <h5>Tipo de Transporte {reqTransport ? " *" : ""}</h5>
                                                            </TextContent>
                                                        )}
                                                        <SpaceBetween direction='horizontal' size='xs'>
                                                            {hasTransport && (
                                                                <SegmentedControl
                                                                    selectedId={transport}
                                                                    onChange={({ detail }) =>
                                                                        setTransport(detail.selectedId)
                                                                    }
                                                                    label="Tipo de Notificación"
                                                                    options={[
                                                                        { text: "Auto", id: "CAR", iconSvg: <Icon path={mdiCarBack} size={0.7} /> },
                                                                        { text: "Moto", id: "MOTO", iconSvg: <Icon path={mdiMotorbike} size={0.7} /> },
                                                                        { text: "Camión", id: "TRUCK", iconSvg: <Icon path={mdiTruckOutline} size={0.7} /> },
                                                                        { text: "Bicicleta", id: "BIKE", iconSvg: <Icon path={mdiBike} size={0.7} /> },
                                                                        { text: "Peatón", id: "WALK", iconSvg: <Icon path={mdiWalk} size={0.7} /> },
                                                                    ]}
                                                                />
                                                            )}
                                                        </SpaceBetween>

                                                        {hasPAX && (
                                                            <FormField
                                                                label={`Ocupantes${reqPAX ? " *" : ""}`}
                                                                constraintText={reqPAX ? "" : "*Campo opcional"}>
                                                                <Input
                                                                    value={PAX}
                                                                    type='number'
                                                                    onChange={({ detail }) => {
                                                                        setPAX(detail.value)
                                                                        setMessages([]);
                                                                    }}
                                                                    placeholder=""
                                                                ></Input>
                                                            </FormField>
                                                        )}
                                                    </SpaceBetween>

                                                )}
                                                {hasCompany && (
                                                    <FormField
                                                        label={`Empresa${reqCompany ? " *" : ""}`}
                                                        constraintText={reqCompany ? "" : "*Campo opcional"}>
                                                        <Input
                                                            value={company}
                                                            onChange={({ detail }) => {
                                                                setCompany(detail.value)
                                                                setMessages([]);
                                                            }}
                                                            placeholder=""
                                                        ></Input>
                                                    </FormField>
                                                )}
                                                {hasPPU && (
                                                    <FormField
                                                        label={`Matrícula${reqPPU ? " *" : ""}`}
                                                        constraintText={reqPPU ? "" : "*Campo opcional"}>
                                                        <Input
                                                            value={PPU}
                                                            onChange={({ detail }) => {
                                                                setPPU(detail.value.toUpperCase())
                                                                setMessages([]);
                                                            }}
                                                            placeholder=""
                                                        ></Input>
                                                    </FormField>
                                                )}
                                                <FormField
                                                    label={`Observaciones`}
                                                    constraintText={reqObsEmisor ? "" : "*Campo opcional"}>
                                                    <Input
                                                        value={obsEmisor}
                                                        onChange={({ detail }) => {
                                                            setObsEmisor(detail.value)
                                                            setMessages([]);
                                                        }}
                                                        placeholder=""
                                                    ></Input>
                                                </FormField>

                                            </>
                                        )}
                                    </>
                                )}
                            </SpaceBetween>
                        </Container>
                    </Form>

                </>
            }
        />
    );
};
